import cookies from "@/utils/cookies";
import { getUserInfo, changeUsername, signOut } from "@/api/index";
import { message } from "@/utils/message.js";
import i18n from "@/lang/index";
const state = {
    TOKEN: cookies.get("access-token") || "",
    // 个人信息
    // PERINFO: localStorage.perInfo
    //     ? JSON.parse(localStorage.getItem("perInfo"))
    //     : "",
    PERINFO: "",
};
const getters = {
    //指定设备百分比
    devPct: (state) => {
        return (
            (state.PERINFO.devBound / state.PERINFO.bindingDevThreshold) * 100
        );
    },
    // 管理设备百分比
    mngPct: (state) => {
        return (
            (state.PERINFO.managedDev / state.PERINFO.managedDevThreshold) * 100
        );
    },
    SET_PERINFO: (state) => state.PERINFO,
};

const mutations = {
    //退出登录
    SIGNOUT(state) {
        // const res = await signOut();
        // if (res.code === 200) {
        //     state.TOKEN = "";
        //     cookies.remove("access-token");
        //     cookies.remove("request_token");
        //     cookies.remove("auth");
        //     localStorage.removeItem("perInfo");
        //     localStorage.removeItem("groupList");
        //     window.open(i18n.t("href.login"), "_self");
        // }
        state.TOKEN = "";
        cookies.remove("access-token");
        cookies.remove("request_token");
        cookies.remove("auth");
        localStorage.removeItem("perInfo");
        localStorage.removeItem("groupList");
        window.open(i18n.t("href.login"), "_self");
    },
    // 设置token
    SET_TOKEN: (state) => {
        const originalToken = cookies.get("request_token");
        const token = originalToken ? originalToken.split(".")[0] : "";
        state.TOKEN = token;
        token &&
            cookies.set("access-token", token, {
                expires: 1,
                path: "/",
            });
        // alert(state.TOKEN);
    },
    // 设置用户信息
    SET_PERINFO(state, data) {
        state.PERINFO = data;
        localStorage.setItem("perInfo", JSON.stringify(state.PERINFO));
    },
    // 更新用户名
    UPDATE_NICKNAME(state, nickName) {
        state.PERINFO.nickName = nickName;
        localStorage.setItem("perInfo", JSON.stringify(state.PERINFO));
    },
    DELPERINFO(state) {
        state.perInfo = null;
        localStorage.removeItem("perInfo");
    },
};

const actions = {
    async setPerinfo({ commit }) {
        // todo email后续换成cookie里面获取
        const res = await getUserInfo();
        console.log(res, "store------------");
        commit("SET_PERINFO", res.data);
    },
    // 更改用户名
    async updateNickname({ commit }, data) {
        const res = await changeUsername(data);
        if (res.code === 200) {
            commit("UPDATE_NICKNAME", data.nickName);
        } else {
            message.error("请重试");
        }
    },
    async signOut({ commit }) {
        const res = await signOut();
        if (res.code === 200) {
            commit("SIGNOUT");
        }
    },
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
